import { render, staticRenderFns } from "./Gacha.vue?vue&type=template&id=40bde50b&"
import script from "./Gacha.vue?vue&type=script&lang=js&"
export * from "./Gacha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports